
import { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Separator } from '@/components/ui/separator';
import type { Application } from '@/types/database.types';

interface MedicalEnrollmentInfoProps {
  register: UseFormRegister<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  data: Partial<Application>;
}

export const MedicalEnrollmentInfo = ({
  register,
  watch,
  setValue,
  data
}: MedicalEnrollmentInfoProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Enrollment Information</h3>
      <Separator className="my-2" />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="employees_enrolled_in_health_plan">
            Total Employees Enrolled in Health Plan
          </Label>
          <Input
            id="employees_enrolled_in_health_plan"
            type="number"
            min="0"
            {...register('employees_enrolled_in_health_plan', { 
              valueAsNumber: true
            })}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="active_pregnancies_count">
            Number of Known Pregnancies
          </Label>
          <Input
            id="active_pregnancies_count"
            type="number"
            min="0"
            {...register('active_pregnancies_count', { 
              valueAsNumber: true
            })}
          />
        </div>
      </div>
      
      <h4 className="font-medium mt-4">Coverage Type Breakdown</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="employee_only_count">
            Employee Only Coverage
          </Label>
          <Input
            id="employee_only_count"
            type="number"
            min="0"
            {...register('employee_only_count', { 
              valueAsNumber: true
            })}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="employee_spouse_count">
            Employee + Spouse Coverage
          </Label>
          <Input
            id="employee_spouse_count"
            type="number"
            min="0"
            {...register('employee_spouse_count', { 
              valueAsNumber: true
            })}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="employee_children_count">
            Employee + Children Coverage
          </Label>
          <Input
            id="employee_children_count"
            type="number"
            min="0"
            {...register('employee_children_count', { 
              valueAsNumber: true
            })}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="employee_family_count">
            Family Coverage
          </Label>
          <Input
            id="employee_family_count"
            type="number"
            min="0"
            {...register('employee_family_count', { 
              valueAsNumber: true
            })}
          />
        </div>
      </div>
    </div>
  );
};
